import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.34 4.16H12v-.54c0-.86-.74-1.56-1.65-1.56h-2.7c-.91 0-1.65.7-1.65 1.56v.54H1.66c-.39 0-.7.31-.7.7v9.78c0 .39.31.7.7.7h14.69c.39 0 .7-.31.7-.7V4.86a.717.717 0 0 0-.71-.7zM7 3.62c0-.3.3-.56.65-.56h2.7c.35 0 .65.26.65.56v.54H7v-.54zm9.04 1.54v2.82h-5.47v-.43c0-.33-.27-.6-.6-.6H8.04c-.33 0-.6.27-.6.6v.43H1.96V5.16h14.08zM9.57 7.95v1.13H8.44V7.95h1.13zm-7.61 6.39V8.99h5.48v.5c0 .33.27.6.6.6h1.93c.33 0 .6-.27.6-.6v-.5h5.47v5.35H1.96z"
    }, null, -1)
  ])))
}
export default { render };